import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'device_mng',
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '设备管理',
        addFunName: 'feedBaitAdd',
        modifyFunName: 'feedBaitModify',
        queryFunName: 'feedBaitQueryJoinLab',
        detailFunName: 'feedBaitDetail',
        delFunName: 'feedBaitDel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        deviceCategory: 'Simulated',
        orientation: true
      },
      model: {
        RCF101: ' RCF101控制器'
      }
      // , model:{ SFT2:' 微型投饲机', RCF101:' RCF101控制器' }
      ,
      rules: {
        id: [{
          required: true,
          message: '请输入设备编号',
          trigger: 'blur'
        }],
        deviceName: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        deviceCategory: [{
          required: true,
          message: '请选择设备类别',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      controlDialogShow: false,
      detailData: {},
      searchFormRecord: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      tableDataRecord: [],
      totalCountRecord: 0,
      deviceCategory: {
        Simulated: '模拟设备',
        Physical: '物理设备'
      },
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false,
      enterprise_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'edit':
          // 设备编辑
          this.edit(command.row);
          break;
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.initFormData(this.emptyFormData);
      this.editDialogShow = true;
    },
    edit: function edit(data) {
      this.initFormData(data);
      this.editDialogTitle = this.pageConfig.editPageName + '维护';
      this.editDialogShow = true;
    },
    getDetail: function getDetail(id) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api[_this.pageConfig.detailFunName](id);
            case 2:
              res = _context.sent;
              if (!(res.code == 200)) {
                _context.next = 8;
                break;
              }
              _this.detailData = res.data || {};
              _context.next = 7;
              return _this.getFeedRecord();
            case 7:
              _this.controlDialogShow = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getFeedRecord: function getFeedRecord() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['feedBaitRecordQuery'](_objectSpread(_objectSpread({}, _this2.searchFormRecord), {}, {
                baitId: _this2.detailData.id
              }));
            case 2:
              res = _context2.sent;
              if (res.code == 200) {
                _this2.tableDataRecord = res.data || [];
                _this2.totalCountRecord = res.count;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.$set(this.formData, 'labId', data.id);
        this.$set(this.formData, 'labName', data.name);
      }
      this.enterprise_show = false;
    } // 投喂记录
    ,
    feedRecord: function feedRecord(course) {
      this.$emit('child-go', course, 'feedRecord');
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.createTime) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    },
    pageChangeRecord: function pageChangeRecord(page) {
      this.searchFormRecord.page = page;
      this.getFeedRecord();
    },
    sizeChangeRecord: function sizeChangeRecord(limit) {
      this.searchFormRecord.page = 1;
      this.searchFormRecord.limit = limit;
      this.getFeedRecord();
    },
    sortChangeRecord: function sortChangeRecord(column) {
      this.searchFormRecord.page = 1;
      this.searchFormRecord.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.getFeedRecord();
    }
  }
};